import { $GQL } from '@GQL/index';
import { type Account } from '@nextgenleads/marketplace-driver';

export async function getAccountSettings(account_id: string, refresh?: boolean): Promise<Partial<Account>> {
	const request = `
			query GetAccountSettings($account_id: ID!) {
				account(id: $account_id) {
					name
					mpid
					display_name
					is_parent
					parent_account_id
					group_ids
					verified
					contact {
						state
						phone
						email
						associated_contacts
					}
					settings {
						timezone
						notifications_bcc_opt_in
						notifications_bcc
						dnc_email
						call_campaigns {
							disable_duration_slider
							limit_duration
							duration_range
						}
						budgets {
							period
							vertical_id
							product
							type
							limit
							enabled
						}
						usha {
							agent_id
							enable_validation
						}
						autocopy_campaigns
						disabled_products
					}
					signup_data {
                        primary_vertical
                        products
                        agency_size
                        referred_from
                        signup_score
                        phone_validation {
                        	phone_number
							is_valid
							activity_score
							line_type
							carrier
							is_prepaid
							error
							warnings
                        }
						agent_license_number	
					}
					support {
						account_manager_id
						status
						category
						date_of_return
						matching_accounts {
							id
							name
							account_manager_id
							created_at
						}
					}
					tags
					status
				}
			}
		`;

	const no_cache = refresh ? ['account'] : undefined;
	return await $GQL.request(request, { account_id, no_cache });
}
